import copy from 'copy-to-clipboard';
import { Renderable, toast } from 'react-hot-toast';

export interface CopyTextToClipBoardOptions {
  withMessage?: boolean;
  successMessage?: string | Renderable;
}

export const copyTextToClipBoard = (text: string, options: CopyTextToClipBoardOptions = {}) => {
  const { withMessage = true, successMessage } = options;

  if (copy(text.toString())) {
    if (withMessage) {
      toast.success(successMessage ?? 'Text copied successfully', {
        id: 'copied',
      });
    }
  }
};
